import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "message-settings",
  "use": "message-settings-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"message-settings\"><path d=\"M2 3v26l5-4h23V3zm26 20H6.3l-.55.44L4 24.84V5h24z\" /><path d=\"M11 11a2 2 0 001.72-1H25V8H12.72a2 2 0 00-3.44 0H7v2h2.28A2 2 0 0011 11zM21 16a2 2 0 001.72-1H25v-2h-2.28a2 2 0 00-3.44 0H7v2h12.28A2 2 0 0021 16zM15 21a2 2 0 001.72-1H25v-2h-8.28a2 2 0 00-3.44 0H7v2h6.28A2 2 0 0015 21z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/message-settings.svg
// module id = R2h9
// module chunks = 39 44